<!-- goods-spec -->

<template>
  <div>
    <van-sku v-model="visible"
      :goods="goods"
      :goods-id="goodsId"
      :hide-stock="sku.hide_stock"
      :initial-sku="initialSku"
      :show-add-cart-btn="!isSeckill && isAddCard"
      :sku="sku"
      @buy-clicked="onBuyClicked_4"
      @add-cart="onAddCartClicked"
      @sku-selected="specValueChange" />
  </div>
</template>

<script>
import { mall_util_order_buy_goods } from "@/util/orders";

export default {
  name: "goods-spec",

  data() {
    return {
      visible: false,
      sku: {},
      goods: {
        picture: this.headImage,
      },
      initialSku: {},

      isAddCard: true
    };
  },

  props: {
    name: { type: String },
    price: { type: Number },
    saleCount: { type: Number },
    goodsId: { type: Number },
    headImage: { type: String },
    spec: { type: String },
    detail: { type: Object },
    specVisible: { type: Boolean, default: false },
    cateCode: { type: String },
    isSeckill: { type: Boolean, default: false },
  },

  model: {
    event: "",
  },

  methods: {
    initSpecInfo(isAddCard) {
      this.isAddCard = isAddCard
      this.visible = true

      this.goods = {
        picture: this.headImage
      };

      budo_log.info('#50 initSpecInfo before parse', this.spec);

      const spec = JSON.parse(this.spec);

      budo_log.info('#54 initSpecInfo after parse', spec);

      const tree = spec.specList.map(sp => {
        return {
          k: sp.name,
          k_s: "p" + sp.specId,
          v: sp.selectedValues.map(p => {
            return { id: p, name: p };
          }),
        };
      });

      const list = [];
      this.initialSku = {
        selectedNum: 1,
      };

      this.getSpList(spec.specList.map((sp) => sp.selectedValues)).forEach((sp, spIndex) => {
        if (!Array.isArray(sp)) {
          sp = [sp];
        }

        const node = spec.specValueList.find(
          item => item.sp.sort().toString() === sp.sort().toString()
        ) || {};

        budo_log.info('#80 initSpecInfo, getSpList', node)

        const spValue = {
          id: sp.sort(),
          price: node.price,
          stock_num: node.stock,
        };

        sp.forEach((_sp, index) => {
          const spNode = spec.specList.find(
            (item) => item.selectedValues.indexOf(_sp) >= 0
          )

          spValue["p" + spNode.specId] = _sp
          budo_log.info('#92 getSpList', spValue)

          if (spIndex === 0) {
            this.initialSku["p" + spNode.specId] = _sp
          }
        })

        list.push(spValue)
      })

      this.sku = {
        tree,
        list,
      };
    },

    onAddCartClicked(e) {
      const goodsInfo = e.selectedSkuComb;
      budo_log.info('#109 onAddCartClicked', goodsInfo)

      mall_util_order_buy_goods(
        e.goodsId,
        e.selectedNum,
        true,
        e.selectedSkuComb.id,
        e.selectedSkuComb.price
      )
    },

    onBuyClicked_4(e) {
      budo_log.info('#136 onBuyClicked_4', e)

      var topicId = this.$route.query.topicId || 0

      mall_util_order_buy_goods(
        this.goodsId,
        e.selectedNum,
        false,
        e.selectedSkuComb.id,
        e.selectedSkuComb.price,
        topicId
      )
    },

    specValueChange(value) {
      this.$emit("spchange", value)
    },

    getSpList(arr) {
      if (arr.length < 2) return arr[0] || []
      return [].reduce.call(arr, function (col, set) {
        let res = []
        col.forEach((c) => {
          set.forEach((s) => {
            let t = [].concat(Array.isArray(c) ? c : [c])
            t.push(s)
            res.push(t)
          })
        })
        return res
      })
    }
  }
}
</script>